import { render, staticRenderFns } from "./CounterChildren.vue?vue&type=template&id=a1f15090&scoped=true&"
import script from "./CounterChildren.vue?vue&type=script&lang=js&"
export * from "./CounterChildren.vue?vue&type=script&lang=js&"
import style0 from "./CounterChildren.vue?vue&type=style&index=0&id=a1f15090&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f15090",
  null
  
)

export default component.exports